import { AuthLayout } from '@ui/components/layouts';
import { SignUpContainer } from '@modules/sign-up/containers/sign_up_container';
import { SignUpForm } from '@modules/sign-up/views/sign_up_view';
import { AuthPublicPageContainer } from '@/src/components/AuthPublicPageContainer';
import { webAppRoutes } from '@/src/lib/navigation/containerPaths';

export function SignUpScreen() {
  return (
    <AuthPublicPageContainer>
      {({ onSuccess, onError, onSuccessNavigate, navigate }) => (
        <AuthLayout>
          <SignUpContainer
            View={SignUpForm}
            onSuccess={onSuccess}
            onError={onError}
            onSuccessNavigate={onSuccessNavigate}
            onNavigateToLogin={() => navigate(webAppRoutes.login)}
            useFormSubmitHandler
          />
        </AuthLayout>
      )}
    </AuthPublicPageContainer>
  );
}
